import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'


const myVariant = {
    hidden: {
        opacity: 0,
       y:100, 
    },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            type: "spring",
            duration: 2.5,
            damping: 20,
            stiffness: 150
        }
    }
}

const Myworks = () => {
    
    return (
        <motion.div className="container" exit={{ x: '-100vw' }} initial={{ x: '100vw' }} animate={{ x: 0 }} transition={{ ease: 'easeInOut' }}>
            
            <div className='Myprojects row mt-5'>
                <div className="col-lg-6 overflow-hidden">
                    
                    
                    <motion.div className='card card-reveal' variants={myVariant} initial={'hidden'} whileInView={'visible'} whileHover={{ scale: 1.05 }} transition={{ type: "spring", stiffness: 400, damping: 10 }} >
                        <div className="overlay">
                            <motion.div initial={{ opacity: 0 }} whileHover={{ x: 0, opacity: 0.8 }} className="overlay-overlay">e-commerce store selling furniture, built using next.js</motion.div>

                            <img className='card-img-top' src={require('../images/Avion/Screenshot (61).png')} alt="" />
                        </div>
                        <div className="card-body">
                            <h2 className="card-title">Avion</h2>
                            <Link to='https://avion-front-end.vercel.app/' target='_blank' className=' opener'><i className="fa-solid fa-up-right-from-square"></i></Link>
                            <Link to='https://github.com/NETEROabdelrahman/Avion-Front-end' target='_blank' className=' git-opener'><i className="fa-brands fa-github"></i></Link>
                        </div>
                    </motion.div>
                  
                    <motion.div className='card card-reveal mt-5' variants={myVariant} initial={'hidden'} whileInView={'visible'} whileHover={{ scale: 1.05 }} transition={{ type: "spring", stiffness: 400, damping: 10 }} >
                        <div className="overlay">
                            <motion.div initial={{ opacity: 0 }} whileHover={{ x: 0, opacity: 0.8 }} className="overlay-overlay">fullstack "MERN" hotel booking app , with full CRUD operation Admin panel.</motion.div>

                            <img className='card-img-top' src={require('../images/booking/Screenshot (53).png')} alt="" />
                        </div>
                        <div className="card-body">
                            <h2 className="card-title">hotel booking</h2>
                            <Link to='https://adel-website-booking-app.netlify.app/' target='_blank' className=' opener'><i className="fa-solid fa-up-right-from-square"></i></Link>
                            <Link to='https://github.com/NETEROabdelrahman/booking-app-frontend' target='_blank' className=' git-opener'><i className="fa-brands fa-github"></i></Link>
                        </div>
                    </motion.div>
                    <motion.div className='card card-reveal mt-5' variants={myVariant} initial={'hidden'} whileInView={'visible'} whileHover={{ scale: 1.05 }} transition={{ type: "spring", stiffness: 400, damping: 10 }}  >
                        <div className="overlay">
                            <motion.div initial={{ opacity: 0 }} whileHover={{ x: 0, opacity: 0.8 }} className="overlay-overlay">an hotel room booking website , gives you describtion and images of available rooms.</motion.div>

                            <img className='card-img-top' src={require("../images/beach-resort/1.png")} alt="" />
                        </div>
                        <div className="card-body position-relative">
                            <h2 className="card-title">beach resort</h2>
                            <Link to='https://adel-website-beach-resort.netlify.app/' target='_blank' className=' opener'><i className="fa-solid fa-up-right-from-square"></i></Link>
                            <Link to='https://github.com/NETEROabdelrahman/beach_resort' target='_blank' className=' git-opener'><i className="fa-brands fa-github"></i></Link>
                        </div>
                    </motion.div>
                    <motion.div className='card card-reveal my-5 ' variants={myVariant} initial={'hidden'} whileInView={'visible'} whileHover={{ scale: 1.05 }} transition={{ type: "spring", stiffness: 400, damping: 10 }} >
                        <div className="overlay">
                            <motion.div initial={{ opacity: 0 }} whileHover={{ x: 0, opacity: 0.8 }} className="overlay-overlay">you may add , remove, change, or view posts as you like, built using react and redux-toolkit.</motion.div>

                            <img className='card-img-top' src={require("../images/posts-app-redux/1.png")} alt="" />
                        </div>
                        <div className="card-body">
                            <h2 className="card-title">posts app</h2>
                            <Link to='https://adel-website-posts.netlify.app/' target='_blank' className=' opener'><i className="fa-solid fa-up-right-from-square"></i></Link>
                            <Link to='https://github.com/NETEROabdelrahman/post-add-redux' target='_blank' className=' git-opener'><i className="fa-brands fa-github"></i></Link>
                        </div>
                    </motion.div>
                    <motion.div className='card card-reveal mb-5' variants={myVariant} initial={'hidden'} whileInView={'visible'} whileHover={{ scale: 1.05 }} transition={{ type: "spring", stiffness: 400, damping: 10 }} >
                        <div className="overlay">
                            <motion.div initial={{ opacity: 0 }} whileHover={{ x: 0, opacity: 0.8 }} className="overlay-overlay">fullstack "NEXT.JS" app ,with google authentication you can add ai prompts,update and delete.</motion.div>

                            <img className='card-img-top' src={require('../images/promptopia/Screenshot (54).png')} alt="" />
                        </div>
                        <div className="card-body">
                            <h2 className="card-title">Promptopia</h2>
                            <Link to='https://promptopia-osn9vll0r-neteroabdelrahman.vercel.app/' target='_blank' className=' opener'><i className="fa-solid fa-up-right-from-square"></i></Link>
                            <Link to='https://github.com/NETEROabdelrahman/Promptopia' target='_blank' className=' git-opener'><i className="fa-brands fa-github"></i></Link>
                        </div>
                    </motion.div>
                    
                </div>
                <div className="col-lg-6 overflow-hidden my-5 my-lg-0">
                    <motion.div className='card card-reveal ' variants={myVariant} initial={'hidden'} whileInView={'visible'} whileHover={{ scale: 1.05 }} transition={{ type: "spring", stiffness: 400, damping: 10 }} >
                        <div className="overlay">
                            <motion.div initial={{ opacity: 0 }} whileHover={{ x: 0, opacity: 0.8 }} className="overlay-overlay">a clone of netflix , full stack "MERN" website.</motion.div>

                            <img className='card-img-top' src={require('../images/netflix/Screenshot (51).png')} alt="" />
                        </div>
                        <div className="card-body">
                            <h2 className="card-title">netflix clone</h2>
                            <Link to='https://adel-website-netflix-clone.netlify.app/' target='_blank' className=' opener'><i className="fa-solid fa-up-right-from-square"></i></Link>
                            <Link to='https://github.com/NETEROabdelrahman/Netflix-Clone' target='_blank' className=' git-opener'><i className="fa-brands fa-github"></i></Link>
                        </div>
                    </motion.div>
                    <motion.div className='card card-reveal mb-5 mt-5' variants={myVariant} initial={'hidden'} whileInView={'visible'} whileHover={{ scale: 1.05 }} transition={{ type: "spring", stiffness: 400, damping: 10 }} >
                        <div className="overlay">
                            <motion.div initial={{ opacity: 0 }} whileHover={{ x: 0, opacity: 0.8 }} className="overlay-overlay">fullstack "NEXT.JS , Express.js" social media app.</motion.div>

                            <img className='card-img-top' src={require('../images/minimal/Screenshot (59).png')} alt="" />
                        </div>
                        <div className="card-body">
                            <h2 className="card-title">Minimal</h2>
                            <Link to='https://minimal-front-end.vercel.app/' target='_blank' className=' opener'><i className="fa-solid fa-up-right-from-square"></i></Link>
                            <Link to='https://github.com/NETEROabdelrahman/Minimal-front-end' target='_blank' className=' git-opener'><i className="fa-brands fa-github"></i></Link>
                        </div>
                    </motion.div>
                    <motion.div className='card card-reveal mt-5' variants={myVariant} initial={'hidden'} whileInView={'visible'} whileHover={{ scale: 1.05 }} transition={{ type: "spring", stiffness: 400, damping: 10 }} >
                        <div className="overlay">
                            <motion.div initial={{ opacity: 0 }} whileHover={{ x: 0, opacity: 0.8 }} className="overlay-overlay">e-commerce phone store , you can choose the phone you want to buy and add it to the cart.</motion.div>

                            <img className='card-img-top' src={require('../images/phone-store/1.png')} alt="" />
                        </div>
                        <div className="card-body">
                            <h2 className="card-title">e-commerce phone store</h2>
                            <Link to='https://adel-website-phone-store.netlify.app/' target='_blank' className=' opener'><i className="fa-solid fa-up-right-from-square"></i></Link>
                            <Link to='https://github.com/NETEROabdelrahman/phone-store' target='_blank' className=' git-opener'><i className="fa-brands fa-github"></i></Link>
                        </div>
                    </motion.div>
                    <motion.div className='card card-reveal my-5' variants={myVariant} initial={'hidden'} whileInView={'visible'} whileHover={{ scale: 1.05 }} transition={{ type: "spring", stiffness: 400, damping: 10 }} >
                        <div className="overlay">
                            <motion.div initial={{ opacity: 0 }} whileHover={{ x: 0, opacity: 0.8 }} className="overlay-overlay">cocktails website gives you the filter method to choose the cocktail you want.</motion.div>

                            <img className='card-img-top' src={require('../images/cocktails/1.png')} alt="" />
                        </div>
                        <div className="card-body">
                            <h2 className="card-title">cocktails</h2>
                            <Link to='https://adel-website-cocktails.netlify.app/' target='_blank' className=' opener'><i className="fa-solid fa-up-right-from-square"></i></Link>
                            <Link to='https://github.com/NETEROabdelrahman/cocktails' target='_blank' className=' git-opener'><i className="fa-brands fa-github"></i></Link>
                        </div>
                    </motion.div>
                    <motion.div className='card card-reveal' variants={myVariant} initial={'hidden'} whileInView={'visible'} whileHover={{ scale: 1.05 }} transition={{ type: "spring", stiffness: 400, damping: 10 }} >
                        <div className="overlay">
                            <motion.div initial={{ opacity: 0 }} whileHover={{ x: 0, opacity: 0.8 }} className="overlay-overlay">full crud operation admin panel, controls the netflix app.</motion.div>

                            <img loading='lazy' className='card-img-top' src={require('../images/admin panel/Screenshot (52).png')} alt="" />
                        </div>
                        <div className="card-body">
                            <h2 className="card-title">admin panel</h2>
                            <Link to='https://adel-website-admin-panel.netlify.app/' target='_blank' className=' opener'><i className="fa-solid fa-up-right-from-square"></i></Link>
                            <Link to='https://github.com/NETEROabdelrahman/netflix-admin-panel' target='_blank' className=' git-opener'><i className="fa-brands fa-github"></i></Link>
                        </div>
                    </motion.div>
                </div>
                
                    
              
              
                  
             
            </div>
                
            
        </motion.div>
    )
};

export default Myworks